var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("chat")]),_c('path',{attrs:{"d":"M19,6.4A1.4,1.4,0,0,0,17.6,5H6.4A1.4,1.4,0,0,0,5,6.4v8.4a1.4,1.4,0,0,0,1.4,1.4h9.8L19,19Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }